<template>
  <div class="mt-3 filter-bar">
    <span>Showing</span>



    <span
      v-if="this.$login.can('analytics.network')"
      :class="`scope scope-network alert ${this.$login.canAnalyticsINTL() ? 'alert-info' : 'alert-success'}`"
    >
      {{ this.$login.canAnalyticsINTL() ? 'INTL Users' : 'Network' }}
    </span>

    <span
      v-else-if="this.$login.can('analytics.channel')"
      class="scope scope-channel alert alert-warning"
    >
      {{ this.$login.getChannelName() }}
    </span>


    <span>data</span>

    <span v-if="switchTimeframe">
      for
    </span>
    <dropdown
      class="timefilter"
      v-model="value"
      @input="onChange"
      v-if="switchTimeframe"
    >
      <template v-slot:trigger>
        {{ options.find(o => o.value === value).label }}
      </template>
      <dropdown-option
        href="javascript:;"
        v-for="item in options"
        :key="item.value"
        :value="item.value"
      >
        {{ item.label }}
      </dropdown-option>
    </dropdown>
  </div>
</template>

<script>
import Dropdown from '@/components/Dropdown/Dropdown'
import DropdownOption from '@/components/Dropdown/DropdownOption'

export default {
  components: {
    Dropdown,
    DropdownOption,
  },
  props: {
    timeframe: {
      type: String,
      required: true,
    },
    switchTimeframe: {
      type: Boolean,
      default: true,
    },
  },

  data () {
    return {
      value: 'this_30_days',
      options: [
        {
          value: 'this_7_days',
          label: 'Last 7 Days',
        },
        {
          value: 'this_30_days',
          label: 'Last 30 Days',
        },
        {
          value: 'this_13_weeks',
          label: 'Last 90 Days',
        },
        {
          value: 'ytd',
          label: 'YTD',
        },
      ],
    }
  },

  mounted () {
    this.value = this.timeframe
  },

  watch: {
    timeframe () {
      this.value = this.timeframe
    },
  },

  methods: {
    onChange (value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss">
  .filter-bar {
    color: $nav-bg;
    .scope {
      padding: 1px 2px 2px 2px;
      margin: 0 0.35rem 0 0.35rem;
      // color: #58666e;
    }
    .timefilter {
      border: 1px solid #e7e7e7;
      border-radius: 3px;
      padding: .25rem 1rem;
      &:hover {
        border-color: #c0c4cc;
      }
      .dropdown-toggle {
        color: #606266;
        &:hover {
          color: #606266;
          text-decoration: none;
        }
      }
    }
  }
</style>
